// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanOmnibusBalanceSummaryRecordDto } from './IPlanOmnibusBalanceSummaryRecordDto';
import {
    IPlanOmnibusBalanceSummaryRecordDtoFromJSON,
    IPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped,
    IPlanOmnibusBalanceSummaryRecordDtoToJSON,
    IPlanOmnibusBalanceSummaryRecordDtoToJSONTyped,
} from './IPlanOmnibusBalanceSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto
 */
export interface IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IPlanOmnibusBalanceSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto
     */
    subsidiary_records?: Array<IPlanOmnibusBalanceSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto(value: object): value is IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto {
    return IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IPlanOmnibusBalanceSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto {
    return IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoPlanOmnibusBalanceSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IPlanOmnibusBalanceSummaryRecordDtoToJSON)),
    };
}

